import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../actions/authActions';
import Message from '../components/ui/Message';
import Loader from '../components/ui/Loader';

const LoginPage = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  const auth = useSelector(state => state.auth);
  const { loading, error, isAuthenticated } = auth;
  
  // Get redirect path from URL query params or default to home
  const redirect = location.search ? location.search.split('=')[1] : '/';
  
  useEffect(() => {
    // If already authenticated, redirect
    if (isAuthenticated) {
      navigate(redirect);
    }
  }, [navigate, isAuthenticated, redirect]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!phoneNumber || !password) {
      return;
    }
    
    // Dispatch login action
    dispatch(login(phoneNumber, password));
  };
  
  return (
    <div className="flex justify-center">
      <div className="w-full max-w-md">
        <h1 className="text-3xl font-bold mb-6 text-center">登录</h1>
        
        {error && <Message variant="error">{error}</Message>}
        
        <div className="bg-white p-6 rounded shadow">
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700 mb-1">手机号码</label>
              <input
                type="tel"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="请输入手机号码"
                className="w-full p-2 border rounded"
                required
              />
            </div>
            
            <div className="mb-6">
              <div className="flex justify-between items-center mb-1">
                <label className="block text-gray-700">密码</label>
                <Link to="/reset-password" className="text-sm text-red-700 hover:underline">
                  忘记密码?
                </Link>
              </div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="请输入密码"
                className="w-full p-2 border rounded"
                required
              />
            </div>
            
            <button
              type="submit"
              className="w-full bg-red-700 text-white py-2 rounded hover:bg-red-800"
              disabled={loading}
            >
              {loading ? <Loader size="sm" /> : '登录'}
            </button>
          </form>
          
          <div className="mt-4 text-center">
            <p>没有账号？ {' '}
              <Link to={redirect ? `/register?redirect=${redirect}` : '/register'} className="text-red-700 hover:underline">
                注册
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;